import React from 'react';
import { scroller } from 'react-scroll';
import router from 'next/router';
import styles from './SaleBanner.module.scss';

export default function SaleBanner() {
  return (
    <div className={styles.SaleBanner}>
      <div className={styles.ActionBlocks}>
        <button
          type="button"
          className={styles.ActionBlock}
          onClick={() => {
            scroller.scrollTo('packages-section', {
              duration: 500,
              delay: 100,
              smooth: true,
            });
          }}
        >
          <div className={styles.PercentOff}>
            Only $89 <span className={styles.Arrow}>→</span>
          </div>
          <div className={styles.ServiceType}>Interior Design Services</div>
        </button>
        <div className={styles.DividerLine} />
        <button
          type="button"
          className={styles.ActionBlock}
          onClick={() => {
            router.push('shop/collection/sale');
          }}
        >
          <div className={styles.PercentOff}>
            <span className={styles.UpTo}>Up To</span>
            <span className={styles.PercentOffText}>
              40% OFF <span className={styles.Arrow}>→</span>
            </span>
          </div>
          <div className={styles.ServiceType}>top home brands</div>
        </button>
      </div>
    </div>
  );
}
